module.exports = __webpack_public_path__ + "img/12-onebg.9cfa488b.jpg";